// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/cormorent/font-cormorant.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/futura/font-futura.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/nunito/font3.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/cardillac/font4.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/arabic/arabic.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/fancy-text-updated.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/fancy-text-updated-rtl.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/fancy-text-sm-updated.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/fancy-text-sm-updated-rtl.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 16px;
  padding-left: 16px;
}
@media (min-width: 480px) {

  .container {
    max-width: 480px;
  }
}
@media (min-width: 576px) {

  .container {
    max-width: 576px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
    padding-right: 24px;
    padding-left: 24px;
  }
}
@media (min-width: 992px) {

  .container {
    max-width: 992px;
    padding-right: 36px;
    padding-left: 36px;
  }
}
@media (min-width: 1200px) {

  .container {
    max-width: 1200px;
  }
}
@media (min-width: 1400px) {

  .container {
    max-width: 1400px;
  }
}
@media (min-width: 1640px) {

  .container {
    max-width: 1640px;
  }
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.\\!end-0 {
  inset-inline-end: 0px !important;
}
.\\!left-\\[unset\\] {
  left: unset !important;
}
.\\!right-\\[unset\\] {
  right: unset !important;
}
.\\!start-0 {
  inset-inline-start: 0px !important;
}
.-bottom-\\[3px\\] {
  bottom: -3px;
}
.-end-\\[100\\%\\] {
  inset-inline-end: -100%;
}
.-end-full {
  inset-inline-end: -100%;
}
.-right-1 {
  right: -0.25rem;
}
.-right-2\\.5 {
  right: -0.625rem;
}
.-right-\\[1px\\] {
  right: -1px;
}
.-start-\\[10px\\] {
  inset-inline-start: -10px;
}
.-start-full {
  inset-inline-start: -100%;
}
.-top-2 {
  top: -0.5rem;
}
.-top-2\\.5 {
  top: -0.625rem;
}
.-top-6 {
  top: -1.5rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-4 {
  bottom: 1rem;
}
.end-0 {
  inset-inline-end: 0px;
}
.end-2 {
  inset-inline-end: 0.5rem;
}
.end-4 {
  inset-inline-end: 1rem;
}
.end-6 {
  inset-inline-end: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-2 {
  left: 0.5rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[18px\\] {
  left: 18px;
}
.left-\\[30\\%\\] {
  left: 30%;
}
.right-0 {
  right: 0px;
}
.right-2 {
  right: 0.5rem;
}
.right-4 {
  right: 1rem;
}
.start-0 {
  inset-inline-start: 0px;
}
.start-2 {
  inset-inline-start: 0.5rem;
}
.start-3 {
  inset-inline-start: 0.75rem;
}
.start-4 {
  inset-inline-start: 1rem;
}
.start-\\[12px\\] {
  inset-inline-start: 12px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-10 {
  top: 2.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-4 {
  top: 1rem;
}
.top-\\[130px\\] {
  top: 130px;
}
.top-\\[17px\\] {
  top: 17px;
}
.top-\\[18px\\] {
  top: 18px;
}
.top-\\[40\\%\\] {
  top: 40%;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[80px\\] {
  top: 80px;
}
.top-\\[8px\\] {
  top: 8px;
}
.\\!z-10 {
  z-index: 10 !important;
}
.z-0 {
  z-index: 0;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.z-\\[100\\] {
  z-index: 100;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[30\\] {
  z-index: 30;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-6 {
  grid-column: span 6 / span 6;
}
.m-auto {
  margin: auto;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mb-10 {
  margin-bottom: 2.5rem !important;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-14 {
  margin-bottom: 3.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[40px\\] {
  margin-bottom: 40px;
}
.me-auto {
  margin-inline-end: auto;
}
.ms-0 {
  margin-inline-start: 0px;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[32px\\] {
  margin-top: 32px;
}
.mt-\\[83px\\] {
  margin-top: 83px;
}
.mb-\\[60px\\] {
  margin-bottom: 60px;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[16\\/9\\] {
  aspect-ratio: 16/9;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-28 {
  height: 7rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[120px\\] {
  height: 120px;
}
.h-\\[140px\\] {
  height: 140px;
}
.h-\\[160px\\] {
  height: 160px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[20px\\] {
  height: 20px;
}
.h-\\[240px\\] {
  height: 240px;
}
.h-\\[280px\\] {
  height: 280px;
}
.h-\\[300px\\] {
  height: 300px;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[360px\\] {
  height: 360px;
}
.h-\\[400px\\] {
  height: 400px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[520px\\] {
  height: 520px;
}
.h-\\[54px\\] {
  height: 54px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[76px\\] {
  height: 76px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[calc\\(100\\%-139px\\)\\] {
  height: calc(100% - 139px);
}
.h-\\[calc\\(100\\%-76px\\)\\] {
  height: calc(100% - 76px);
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[240px\\] {
  max-height: 240px;
}
.max-h-\\[30px\\] {
  max-height: 30px;
}
.max-h-\\[520px\\] {
  max-height: 520px;
}
.max-h-\\[calc\\(100vh-78px\\)\\] {
  max-height: calc(100vh - 78px);
}
.max-h-\\[min\\(90vh\\2c 720px\\)\\] {
  max-height: min(90vh, 720px);
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[100px\\] {
  min-height: 100px;
}
.min-h-\\[130px\\] {
  min-height: 130px;
}
.min-h-\\[150px\\] {
  min-height: 150px;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[400px\\] {
  min-height: 400px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[54px\\] {
  min-height: 54px;
}
.min-h-\\[58px\\] {
  min-height: 58px;
}
.min-h-\\[calc\\(100vh-224px\\)\\] {
  min-height: calc(100vh - 224px);
}
.min-h-\\[calc\\(100vh-240px\\)\\] {
  min-height: calc(100vh - 240px);
}
.min-h-\\[inherit\\] {
  min-height: inherit;
}
.min-h-full {
  min-height: 100%;
}
.\\!w-auto {
  width: auto !important;
}
.\\!w-full {
  width: 100% !important;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-3\\/4 {
  width: 75%;
}
.w-4 {
  width: 1rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[145px\\] {
  width: 145px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[194\\.64px\\] {
  width: 194.64px;
}
.w-\\[20px\\] {
  width: 20px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[48px\\] {
  width: 48px;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[80px\\] {
  width: 80px;
}
.w-auto {
  width: auto;
}
.w-fit {
  width: fit-content;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.w-screen {
  width: 100vw;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[250px\\] {
  min-width: 250px;
}
.min-w-\\[56px\\] {
  min-width: 56px;
}
.min-w-\\[78px\\] {
  min-width: 78px;
}
.min-w-\\[96px\\] {
  min-width: 96px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-\\[120px\\] {
  max-width: 120px;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[300px\\] {
  max-width: 300px;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-\\[80\\%\\] {
  max-width: 80%;
}
.max-w-\\[90\\%\\] {
  max-width: 90%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.max-w-xl {
  max-width: 36rem;
}
.max-w-full {
  max-width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.border-collapse {
  border-collapse: collapse;
}
.\\!translate-y-0 {
  --tw-translate-y: 0px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1 {
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-90deg\\] {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-col-reverse {
  flex-direction: column-reverse;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[48px\\] {
  gap: 48px;
}
.gap-\\[4px\\] {
  gap: 4px;
}
.gap-lg {
  gap: 32px;
}
.gap-md {
  gap: 24px;
}
.gap-sm {
  gap: 12px;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.\\!rounded-none {
  border-radius: 0px !important;
}
.\\!rounded-sm {
  border-radius: 8px !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-\\[6px\\] {
  border-radius: 6px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 32px;
}
.rounded-md {
  border-radius: 16px;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-sm {
  border-radius: 8px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-s-sm {
  border-start-start-radius: 8px;
  border-end-start-radius: 8px;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-e {
  border-inline-end-width: 1px;
}
.border-e-0 {
  border-inline-end-width: 0px;
}
.border-r {
  border-right-width: 1px;
}
.border-s {
  border-inline-start-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#101010\\] {
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity, 1));
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 211 77 / var(--tw-border-opacity, 1));
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-black\\/50 {
  border-color: rgb(0 0 0 / 0.5);
}
.border-black\\/60 {
  border-color: rgb(0 0 0 / 0.6);
}
.border-dark {
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity, 1));
}
.border-dark\\/20 {
  border-color: rgb(16 16 16 / 0.2);
}
.border-emerald-300 {
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-dark {
  --tw-border-opacity: 1;
  border-color: rgb(118 119 123 / var(--tw-border-opacity, 1));
}
.border-gray-mid {
  --tw-border-opacity: 1;
  border-color: rgb(226 226 226 / var(--tw-border-opacity, 1));
}
.border-gray-mid\\/60 {
  border-color: rgb(226 226 226 / 0.6);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-b-gray-mid {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(226 226 226 / var(--tw-border-opacity, 1));
}
.border-t-dark {
  --tw-border-opacity: 1;
  border-top-color: rgb(16 16 16 / var(--tw-border-opacity, 1));
}
.\\!bg-black {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#000000\\]\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}
.bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/25 {
  background-color: rgb(0 0 0 / 0.25);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity, 1));
}
.bg-dark\\/20 {
  background-color: rgb(16 16 16 / 0.2);
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-gold {
  --tw-bg-opacity: 1;
  background-color: rgb(167 129 92 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-light {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}
.bg-gray-mid {
  --tw-bg-opacity: 1;
  background-color: rgb(226 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/65 {
  background-color: rgb(255 255 255 / 0.65);
}
.bg-white\\/90 {
  background-color: rgb(255 255 255 / 0.9);
}
.bg-opacity-25 {
  --tw-bg-opacity: 0.25;
}
.bg-opacity-35 {
  --tw-bg-opacity: 0.35;
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-black\\/45 {
  --tw-gradient-from: rgb(0 0 0 / 0.45) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-transparent {
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-fixed {
  background-attachment: fixed;
}
.bg-\\[position\\:100\\%_center\\] {
  background-position: 100% center;
}
.bg-center {
  background-position: center;
}
.bg-right {
  background-position: right;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-fill {
  object-fit: fill;
}
.object-center {
  object-position: center;
}
.object-top {
  object-position: top;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[14px\\] {
  padding: 14px;
}
.p-\\[2px_4px\\] {
  padding: 2px 4px;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-5 {
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-\\[15px\\] {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-14 {
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[18px\\] {
  padding-left: 18px;
  padding-right: 18px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[14px\\] {
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[60px\\] {
  padding-top: 60px;
  padding-bottom: 60px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[80px\\] {
  padding-top: 80px;
  padding-bottom: 80px;
}
.\\!pb-0 {
  padding-bottom: 0px !important;
}
.\\!pt-8 {
  padding-top: 2rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-10 {
  padding-bottom: 2.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-\\[18px\\] {
  padding-bottom: 18px;
}
.pe-0 {
  padding-inline-end: 0px;
}
.pe-10 {
  padding-inline-end: 2.5rem;
}
.pe-12 {
  padding-inline-end: 3rem;
}
.pe-14 {
  padding-inline-end: 3.5rem;
}
.pe-4 {
  padding-inline-end: 1rem;
}
.pe-8 {
  padding-inline-end: 2rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.ps-0 {
  padding-inline-start: 0px;
}
.ps-1 {
  padding-inline-start: 0.25rem;
}
.ps-14 {
  padding-inline-start: 3.5rem;
}
.ps-3 {
  padding-inline-start: 0.75rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.ps-8 {
  padding-inline-start: 2rem;
}
.ps-\\[52px\\] {
  padding-inline-start: 52px;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-14 {
  padding-top: 3.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.pt-\\[15px\\] {
  padding-top: 15px;
}
.pt-\\[2px\\] {
  padding-top: 2px;
}
.pt-\\[74px\\] {
  padding-top: 74px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.text-end {
  text-align: end;
}
.align-middle {
  vertical-align: middle;
}
.\\!font-cardillac {
  font-family: Cardillac !important;
}
.\\!font-cormorant {
  font-family: Cormorant Garamond !important;
}
.\\!font-nunito {
  font-family: Nunito !important;
}
.font-cormorant {
  font-family: Cormorant Garamond;
}
.font-futura {
  font-family: Futura Bk BT;
}
.font-nunito {
  font-family: Nunito;
}
.\\!text-\\[10px\\] {
  font-size: 10px !important;
}
.\\!text-base {
  font-size: 16px !important;
}
.\\!text-base-20 {
  font-size: 20px !important;
}
.\\!text-sm {
  font-size: 14px !important;
}
.\\!text-xs {
  font-size: 12px !important;
}
.text-2xl {
  font-size: 40px;
}
.text-5xl {
  font-size: 3rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-base {
  font-size: 16px;
}
.text-base-18 {
  font-size: 18px;
}
.text-base-20 {
  font-size: 20px;
}
.text-lg {
  font-size: 24px;
}
.text-lg-28 {
  font-size: 28px;
}
.text-sm {
  font-size: 14px;
}
.text-xl {
  font-size: 32px;
}
.text-xs {
  font-size: 12px;
}
.\\!font-600 {
  font-weight: 600 !important;
}
.\\!font-700 {
  font-weight: 700 !important;
}
.font-300 {
  font-weight: 300;
}
.font-400 {
  font-weight: 400;
}
.font-500 {
  font-weight: 500;
}
.font-600 {
  font-weight: 600;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.italic {
  font-style: italic;
}
.leading-1 {
  line-height: 1;
}
.leading-1\\.5 {
  line-height: 1.5;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[50px\\] {
  line-height: 50px;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.leading-none {
  line-height: 1;
}
.tracking-\\[8px\\] {
  letter-spacing: 8px;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-danger {
  --tw-text-opacity: 1;
  color: rgb(211 15 28 / var(--tw-text-opacity, 1));
}
.text-dark {
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}
.text-dark\\/60 {
  color: rgb(16 16 16 / 0.6);
}
.text-dark\\/70 {
  color: rgb(16 16 16 / 0.7);
}
.text-dark\\/80 {
  color: rgb(16 16 16 / 0.8);
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-gray-dark {
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
}
.text-gray-mid {
  --tw-text-opacity: 1;
  color: rgb(226 226 226 / var(--tw-text-opacity, 1));
}
.text-gray-mix {
  --tw-text-opacity: 1;
  color: rgb(135 150 153 / var(--tw-text-opacity, 1));
}
.text-gray-new\\/50 {
  color: rgb(66 62 59 / 0.5);
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-success {
  --tw-text-opacity: 1;
  color: rgb(55 182 88 / var(--tw-text-opacity, 1));
}
.text-success-dark {
  --tw-text-opacity: 1;
  color: rgb(75 174 79 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-90 {
  opacity: 0.9;
}
.bg-blend-overlay {
  background-blend-mode: overlay;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-mega-menu {
  --tw-shadow: -13px 43px 69px -25px rgba(0,0,0,0.41);
  --tw-shadow-colored: -13px 43px 69px -25px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-search-toggle {
  --tw-shadow: -13px 43px 69px -25px rgba(0,0,0,0.41);
  --tw-shadow-colored: -13px 43px 69px -25px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\!outline-none {
  outline: 2px solid transparent !important;
  outline-offset: 2px !important;
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.outline-0 {
  outline-width: 0px;
}
.outline-1 {
  outline-width: 1px;
}
.outline-offset-2 {
  outline-offset: 2px;
}
.outline-black {
  outline-color: #000;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-black {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}
.ring-opacity-5 {
  --tw-ring-opacity: 0.05;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
/* @import "./assets/fonts/jost/font1.css";
@import "./assets/fonts/ledger/font2.css";
@import "./assets/fonts/nunito/font3.css"; */

.container {
  max-width: 100%;
}

@media (min-width: 1400px) {

  .container {
    max-width: 1340px;
  }
}

@media (min-width: 1640px) {

  .container {
    max-width: 1480px;
  }
}

* {
  -webkit-tap-highlight-color: transparent;
}
html {
  overflow-x: hidden;
}
body {
  font-family: Futura Bk BT;
}

body[dir="rtl"] body {
  font-family: Droid Arabic Kufi !important;
}
.hero-section {
  /* background-image: url("./assets/images/banner-hero-4.jpg"); */
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s;
  transition: background-color 0s 600000s, color 0s 600000s;
}

.new-arrive-content p {
  margin-bottom: 1.25rem;
  font-size: 18px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
p.new-arrive-content {
  margin-bottom: 1.25rem;
  font-size: 18px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.new-arrive-content {
  margin-bottom: 1.25rem;
  font-size: 18px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.product-card-content p {
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  font-size: 12px;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 576px) {

  .product-card-content p {
    max-width: 80%;
    font-size: 14px;
  }
}

.product-card-content {
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-align: center;
  font-size: 12px;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

@media (min-width: 576px) {

  .product-card-content {
    max-width: 80%;
    font-size: 14px;
  }
}

/* Global button styling */
button {
  border-radius: 9999px;
}

.btn-theme {
  z-index: 1;
}

.btn-theme::before {
  transition: transfrom 0.3s;
  transform-origin: 0 0;
  transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);
  transform: scaleY(0);
}

.btn-theme:hover::before {
  transform: scaleY(1);
}

.btn-theme:disabled::before {
  transform: scaleY(0);
}
a {
  display: inline-block;
}

.page-404-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.page-404-wrapper .page_404_btn {
  position: absolute;
  bottom: 10%;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

input[type="number"] {
  appearance: textfield;
}

.slick-track {
  display: flex !important;
}

.slider_flex .slick-track {
  display: flex !important;
}

.slider_flex .slick-track .slick-slide {
  height: inherit !important;
}

.slider_flex .slick-track .slick-slide > div,
.slider_flex .slick-track .slick-slide .slider_item,
.slider_flex .slick-track .slick-slide .slider_item > div {
  height: 100% !important;
}

/* Ensure slider container has proper width for responsive calculations */
.slide_gap24.slick-slider .slick-list {
  width: 100%;
  overflow: hidden;
}

/* New Collection Swiper Pagination Styles */
.new-collection-swiper .swiper-pagination {
  position: relative;
  margin-top: 24px;
  bottom: auto;
}

.new-collection-swiper .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #d1d1d1;
  opacity: 1;
  margin: 0 4px;
  transition: all 0.3s ease;
}

.new-collection-swiper .swiper-pagination-bullet-active {
  background: #000;
  width: 24px;
  border-radius: 4px;
}

/* Hide pagination on tablet and desktop */
@media (min-width: 768px) {
  .new-collection-swiper .swiper-pagination {
    display: none;
  }
}

/* Popular Collection Swiper Pagination Styles */
.popular-collection-swiper .swiper-pagination {
  position: relative;
  margin-top: 24px;
  bottom: auto;
}

.popular-collection-swiper .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #d1d1d1;
  opacity: 1;
  margin: 0 4px;
  transition: all 0.3s ease;
}

.popular-collection-swiper .swiper-pagination-bullet-active {
  background: #000;
  width: 24px;
  border-radius: 4px;
}

/* Hide pagination on tablet and desktop */
@media (min-width: 768px) {
  .popular-collection-swiper .swiper-pagination {
    display: none;
  }
}

.slide_gap24.slick-slider {
  margin-left: -12px;
  margin-right: -12px;
}

.slide_gap24 .slick-slide {
  margin-left: 12px;
  margin-right: 12px;
}

.slide_gap16.slick-slider {
  margin-left: -8px;
  margin-right: -8px;
}

.slide_gap16 .slick-slide {
  margin-left: 8px;
  margin-right: 8px;
}

.slide_gap12.slick-slider {
  margin-left: -6px;
  margin-right: -6px;
}

.slide_gap12 .slick-slide {
  margin-left: 6px;
  margin-right: 6px;
}
.slide_gap8.slick-slider {
  margin-left: -4px;
  margin-right: -4px;
}

.slide_gap8.slick-slide {
  margin-left: 4px;
  margin-right: 4px;
}

h1 {
  font-size: 50px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

h2 {
  font-size: 40px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

h3 {
  font-size: 32px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

h4 {
  font-size: 24px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

h5 {
  font-size: 20px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

h6 {
  font-size: 18px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

p {
  font-size: 14px;
  line-height: 1.5;
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
}

label {
  line-height: 1.5;
}

.section-gap {
  padding-top: 32px;
  padding-bottom: 32px;
}

@media (min-width: 768px) {

  .section-gap {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}

@media (min-width: 992px) {

  .section-gap {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}

.slick-arrow::before {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.radio-slider.slick-slider {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.radio-slider.slick-slider .slick-arrow.slick-prev {
  left: 0px;
}

.radio-slider.slick-slider .slick-arrow.slick-next {
  right: 0px;
}

.hidden-scrollbar::-webkit-scrollbar {
  display: none;
}

.theme-scrollbar::-webkit-scrollbar {
  width: 0.25rem;
}

.theme-scrollbar::-webkit-scrollbar-track {
  width: 0.25rem;
}

.theme-scrollbar::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

::-webkit-scrollbar {
  width: 0.25rem;
}

::-webkit-scrollbar-track {
  width: 0.25rem;
}

::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.custom-otp-input-wrapper input {
  height: 50px;
  width: 60px !important;
  border-radius: 9999px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(226 226 226 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  font-size: 16px;
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.custom-otp-input-wrapper input:focus {
  border-color: rgb(0 0 0 / 0.1);
  background-color: rgb(167 129 92 / 0.1);
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.custom-otp-input-wrapper > div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

input.peer-sorting:checked + label > span {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

input.peer-sorting:checked + label > span::before {
  content: var(--tw-content);
  display: block;
}

input.peer-sorting:checked + label {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.sorting-range {
  height: 6px;
  --tw-bg-opacity: 1;
  background-color: rgb(246 242 239 / var(--tw-bg-opacity, 1));
}

.sorting-range .track-1 {
  height: 6px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.sorting-range .thumb {
  top: -5px;
  height: 1rem;
  width: 1rem;
  cursor: pointer;
  border-radius: 9999px;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.sorting-range .thumb.active {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.custome_rating span svg {
  height: 50px;
  width: 50px;
}

.custome_rating span svg.text-yellow-700 {
  fill: #fbc02d;
}

.custome_rating span svg.text-blue-gray-500 {
  stroke: #95a9b2;
}

.sub-slider .slick-slider .slick-arrow::before {
  content: "";
}

.sub-slider .slick-slider .slick-slide .product-img-tiny {
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}

.sub-slider .slick-slider .slick-slide.slick-current .product-img-tiny {
  border-width: 3px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

/* .slick-slider.gap-16 .slick-track{
    gap: 16px;
    margin-left: 16px;
    
}

.slick-slider.gap_0 .slick-track{
    gap: 0;
    margin-left: -12px;
    margin-right: -12px;
    
} */

.slick-slider.fixed_slider .slick-track {
  left: 0 !important;
}

.slick-slider.related_slider .slick-track {
  left: 0 !important;
}

.slick-slider.new_collection_slider .slick-track {
  left: 0 !important;
}

.custom_pagination .page-item {
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
}

.custom_pagination .page-item.active {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.slick-dots {
  bottom: -30px;
}

@media (min-width: 992px) {
  .filter_part {
      position: sticky !important;
      top: 75px !important;
      align-self: flex-start;
  }
  
  .search-results-section-content {
      overflow: visible;
  }
  
  .search-results-section {
      overflow: visible;
  }
}

@media (max-width: 576px) {
  .slick-slider.fixed_slider .slick-track {
    left: 30px !important;
  }

  .slick-slider.related_slider .slick-track {
    left: 30px !important;
  }

  .slick-slider.new_collection_slider .slick-track {
    left: -5px !important;
  }
}

@media (max-width: 992px) {
  .sub-menu-anime {
    animation: 0.5s ease 0s 1 normal forwards running slideRight;
  }
}

@keyframes slideRight {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }

  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

/* 
.new-arrives-section{
    background-image: url("./assets/images/banner-bg.png");
} */

.location-info-section h5 {
  max-width: 130px;
  overflow-x: hidden;
  overflow-y: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: Nunito !important;
}

.custom-dots .slick-dots {
  display: flex !important;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.custom-dots .slick-dots li {
  width: 6px;
  height: 6px;
  border-radius: 12px;
  background-color: #76777b99;
  display: block;
  padding: 0px;
  margin: 0px;
  transition: all 0.5s ease;
  bottom: 12px;
}

.custom-dots .slick-dots li button {
  height: unset;
  width: unset;
  padding: 0;
}

.custom-dots .slick-dots li button:before {
  display: none;
}

.custom-dots .slick-dots li.slick-active {
  width: 16px;
  background-color: #76777b;
}

[dir="rtl"] .slick-slide {
  float: none !important;
}

.fancy-heading-shape {
  position: relative;
  /* background-color: #ffffff; */
}

.fancy-heading-shape::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  top: 58%;
  left: 0;
  transform: translate(-50%, -50%);
  z-index: -1;
}

body[dir="rtl"] .fancy-heading-shape::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  right: 0;
  left: unset;
  transform: translate(50%, -50%);
}

@media (max-width: 768px) {
  .fancy-heading-shape::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  body[dir="rtl"] .fancy-heading-shape::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    right: 0;
    left: unset;
    transform: translate(50%, -50%);
  }
}

body[dir="rtl"],
body[dir="rtl"] .font-cormorant,
body[dir="rtl"] .font-futura {
  font-family: Droid Arabic Kufi !important;
}

.legal-docs h4 {
  margin-bottom: 0.25rem;
  font-size: 24px;
}
.legal-docs p {
  margin-bottom: 0.75rem;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

.legal-docs h4 strong {
  font-family: Cormorant Garamond;
  font-weight: 600;
}


body[dir="rtl"] .legal-docs h4 strong {
  font-family: Droid Arabic Kufi !important;
}

.legal-docs h4 strong:where([dir="rtl"], [dir="rtl"] *) {
  font-weight: 500;
}
.legal-docs ul {
  margin-bottom: 0.75rem;
}
.legal-docs ul li {
  position: relative;
  margin-bottom: 0.5rem;
  display: block;
  padding-inline-start: 0.75rem;
  font-size: 16px;
  font-weight: 400;
}
.legal-docs ul li::before {
  position: absolute;
  top: 0.625rem;
  inset-inline-start: 0px;
  height: 0.25rem;
  width: 0.25rem;
  border-radius: 9999px;
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity, 1));
}
/* slider  */
.product-details-slider.slick-slider,
.product-details-slider.slick-slider .slick-list,
.product-details-slider.slick-slider .slick-list .slick-track,
.product-details-slider.slick-slider .slick-list .slick-track .slick-slide,
.product-details-slider.slick-slider
  .slick-list
  .slick-track
  .slick-slide
  > div,
.product-details-slider.slick-slider
  .slick-list
  .slick-track
  .slick-slide
  > div
  .product-main-img {
  height: 100%;
}

.product-details-slider.slick-slider .slick-list {
  height: 100%;
}

.slick-slide {
  z-index: 990;
}

.slick-active.slick-current {
  z-index: 991;
}

.gm-ui-hover-effect {
  top: 0 !important;
  right: 0 !important;
  width: auto !important;
  height: auto !important;

  span {
    font-size: 20px !important;
    width: 20px !important;
    height: 20px !important;
  }
}

/* Pagination active page styling */
.active-page {
  border-radius: 0.25rem;
  border-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
  min-width: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background-color: #f6f2ef;
}

/* Responsive pagination default styling */
.react-responsive-pagination .pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.react-responsive-pagination .pagination li {
  list-style-type: none;
}

.react-responsive-pagination .pagination a {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.react-responsive-pagination .pagination a:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.react-responsive-pagination .pagination a {
  min-width: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
}

.placeholder\\:text-sm::placeholder {
  font-size: 14px;
}

.placeholder\\:capitalize::placeholder {
  text-transform: capitalize;
}

.placeholder\\:text-black::placeholder {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-dark::placeholder {
  --tw-text-opacity: 1;
  color: rgb(118 119 123 / var(--tw-text-opacity, 1));
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:-bottom-\\[2px\\]::before {
  content: var(--tw-content);
  bottom: -2px;
}

.before\\:bottom-0::before {
  content: var(--tw-content);
  bottom: 0px;
}

.before\\:left-1\\/2::before {
  content: var(--tw-content);
  left: 50%;
}

.before\\:start-0::before {
  content: var(--tw-content);
  inset-inline-start: 0px;
}

.before\\:start-1\\/2::before {
  content: var(--tw-content);
  inset-inline-start: 50%;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:top-1\\/2::before {
  content: var(--tw-content);
  top: 50%;
}

.before\\:top-2\\.5::before {
  content: var(--tw-content);
  top: 0.625rem;
}

.before\\:\\!-z-\\[1\\]::before {
  content: var(--tw-content);
  z-index: -1 !important;
}

.before\\:inline-block::before {
  content: var(--tw-content);
  display: inline-block;
}

.before\\:\\!hidden::before {
  content: var(--tw-content);
  display: none !important;
}

.before\\:hidden::before {
  content: var(--tw-content);
  display: none;
}

.before\\:h-2\\.5::before {
  content: var(--tw-content);
  height: 0.625rem;
}

.before\\:h-\\[1px\\]::before {
  content: var(--tw-content);
  height: 1px;
}

.before\\:h-\\[2px\\]::before {
  content: var(--tw-content);
  height: 2px;
}

.before\\:h-\\[5px\\]::before {
  content: var(--tw-content);
  height: 5px;
}

.before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}

.before\\:w-0::before {
  content: var(--tw-content);
  width: 0px;
}

.before\\:w-2\\.5::before {
  content: var(--tw-content);
  width: 0.625rem;
}

.before\\:w-\\[100\\%\\]::before {
  content: var(--tw-content);
  width: 100%;
}

.before\\:w-\\[5px\\]::before {
  content: var(--tw-content);
  width: 5px;
}

.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.before\\:flex-grow::before {
  content: var(--tw-content);
  flex-grow: 1;
}

.before\\:-translate-x-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:-translate-y-1\\/2::before {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}

.before\\:bg-black::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.before\\:bg-gold::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(167 129 92 / var(--tw-bg-opacity, 1));
}

.before\\:bg-gray-mid::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(226 226 226 / var(--tw-bg-opacity, 1));
}

.before\\:transition-all::before {
  content: var(--tw-content);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.before\\:duration-300::before {
  content: var(--tw-content);
  transition-duration: 300ms;
}

.before\\:ease-in-out::before {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.before\\:content-\\[\\'\\'\\]::before {
  --tw-content: '';
  content: var(--tw-content);
}

.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}

.after\\:-end-\\[18px\\]::after {
  content: var(--tw-content);
  inset-inline-end: -18px;
}

.after\\:top-1\\/2::after {
  content: var(--tw-content);
  top: 50%;
}

.after\\:inline-block::after {
  content: var(--tw-content);
  display: inline-block;
}

.after\\:h-3\\/4::after {
  content: var(--tw-content);
  height: 75%;
}

.after\\:h-\\[1px\\]::after {
  content: var(--tw-content);
  height: 1px;
}

.after\\:w-0\\.5::after {
  content: var(--tw-content);
  width: 0.125rem;
}

.after\\:flex-grow::after {
  content: var(--tw-content);
  flex-grow: 1;
}

.after\\:-translate-y-1\\/2::after {
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.after\\:\\!bg-\\[\\#101010\\]\\/20::after {
  content: var(--tw-content);
  background-color: rgb(16 16 16 / 0.2) !important;
}

.after\\:bg-gray-mid::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(226 226 226 / var(--tw-bg-opacity, 1));
}

.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:mb-2:last-child {
  margin-bottom: 0.5rem;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:border-b:last-child {
  border-bottom-width: 1px;
}

.last\\:border-b-gold-light:last-child {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(246 242 239 / var(--tw-border-opacity, 1));
}

.last\\:after\\:hidden:last-child::after {
  content: var(--tw-content);
  display: none;
}

.checked\\:accent-gold:checked {
  accent-color: #A7815C;
}

.focus-within\\:relative:focus-within {
  position: relative;
}

.focus-within\\:z-20:focus-within {
  z-index: 20;
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:\\!border-black:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1)) !important;
}

.hover\\:\\!border-transparent:hover {
  border-color: transparent !important;
}

.hover\\:border-dark:hover {
  --tw-border-opacity: 1;
  border-color: rgb(16 16 16 / var(--tw-border-opacity, 1));
}

.hover\\:border-transparent:hover {
  border-color: transparent;
}

.hover\\:\\!bg-\\[unset\\]:hover {
  background-color: unset !important;
}

.hover\\:\\!bg-black:hover {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
}

.hover\\:\\!bg-transparent:hover {
  background-color: transparent !important;
}

.hover\\:bg-\\[unset\\]:hover {
  background-color: unset;
}

.hover\\:bg-black:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-dark:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 16 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gold-mid:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(235 221 210 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-mid:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-mid\\/80:hover {
  background-color: rgb(226 226 226 / 0.8);
}

.hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:font-400:hover {
  font-weight: 400;
}

.hover\\:\\!text-black:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.hover\\:text-dark:hover {
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:\\!border-none:focus {
  border-style: none !important;
}

.focus\\:\\!border-red-500:focus {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}

.focus\\:border-black:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}

.focus\\:border-black\\/10:focus {
  border-color: rgb(0 0 0 / 0.1);
}

.focus\\:border-gray-dark:focus {
  --tw-border-opacity: 1;
  border-color: rgb(118 119 123 / var(--tw-border-opacity, 1));
}

.focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}

.focus\\:bg-gray-mid\\/10:focus {
  background-color: rgb(226 226 226 / 0.1);
}

.focus\\:text-black:focus {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.placeholder\\:focus\\:text-black:focus::placeholder {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-blue-500:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-dark\\/25:focus-visible {
  --tw-ring-color: rgb(16 16 16 / 0.25);
}

.focus-visible\\:ring-offset-2:focus-visible {
  --tw-ring-offset-width: 2px;
}

.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-gray-dark:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(118 119 123 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

.group:hover .group-hover\\:ms-2 {
  margin-inline-start: 0.5rem;
}

.group\\/card:hover .group-hover\\/card\\:h-\\[30px\\] {
  height: 30px;
}

.group\\/card:hover .group-hover\\/card\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105 {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}

.group\\/handleradd:hover .group-hover\\/handleradd\\:\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.group\\/handlersub:hover .group-hover\\/handlersub\\:\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.group\\/link:hover .group-hover\\/link\\:\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.group\\/nav:hover .group-hover\\/nav\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/searchtoogle:hover .group-hover\\/searchtoogle\\:\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.group\\/submenu:hover .group-hover\\/submenu\\:\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.group:hover .group-hover\\:text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group\\/card:hover .group-hover\\/card\\:opacity-0 {
  opacity: 0;
}

.group\\/card:hover .group-hover\\/card\\:opacity-100 {
  opacity: 1;
}

.group\\/submenu:hover .group-hover\\/submenu\\:before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.group\\/submenu:hover .group-hover\\/submenu\\:before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.group.hasScrolled .group-\\[\\.hasScrolled\\]\\:\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}

.group.hasScrolled .group-\\[\\.hasScrolled\\]\\:\\!text-black {
  --tw-text-opacity: 1 !important;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1)) !important;
}

.aria-selected\\:opacity-100[aria-selected="true"] {
  opacity: 1;
}

.aria-selected\\:opacity-30[aria-selected="true"] {
  opacity: 0.3;
}

@media not all and (min-width: 992px) {

  .max-lg\\:fixed {
    position: fixed;
  }

  .max-lg\\:border-b {
    border-bottom-width: 1px;
  }

  .max-lg\\:py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
}

@media (max-width: 992px) {

  .max-\\[992px\\]\\:max-w-full {
    max-width: 100%;
  }

  .max-\\[992px\\]\\:p-0 {
    padding: 0px;
  }
}

@media not all and (min-width: 576px) {

  .max-sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .max-sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .max-sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .max-sm\\:aspect-square {
    aspect-ratio: 1 / 1;
  }

  .max-sm\\:object-cover {
    object-fit: cover;
  }

  .max-sm\\:object-center {
    object-position: center;
  }

  .max-sm\\:py-\\[30px\\] {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .max-sm\\:text-center {
    text-align: center;
  }
}

@media not all and (min-width: 480px) {

  .max-xsm\\:h-\\[300px\\] {
    height: 300px;
  }

  .max-xsm\\:w-full {
    width: 100%;
  }

  .max-xsm\\:flex-col {
    flex-direction: column;
  }

  .max-xsm\\:pb-0 {
    padding-bottom: 0px;
  }

  .max-xsm\\:pb-4 {
    padding-bottom: 1rem;
  }
}

@media (min-width: 400px) {

  .min-\\[400px\\]\\:text-sm {
    font-size: 14px;
  }
}

@media (min-width: 480px) {

  .xsm\\:h-\\[200px\\] {
    height: 200px;
  }

  .xsm\\:h-\\[320px\\] {
    height: 320px;
  }

  .xsm\\:h-\\[400px\\] {
    height: 400px;
  }

  .xsm\\:h-\\[420px\\] {
    height: 420px;
  }

  .xsm\\:h-\\[80px\\] {
    height: 80px;
  }

  .xsm\\:w-\\[120px\\] {
    width: 120px;
  }

  .xsm\\:max-w-\\[140px\\] {
    max-width: 140px;
  }

  .xsm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xsm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xsm\\:text-xs {
    font-size: 12px;
  }
}

@media (min-width: 576px) {

  .sm\\:bottom-5 {
    bottom: 1.25rem;
  }

  .sm\\:left-1\\/2 {
    left: 50%;
  }

  .sm\\:right-5 {
    right: 1.25rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:mb-3\\.5 {
    margin-bottom: 0.875rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:mt-\\[78px\\] {
    margin-top: 78px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:aspect-square {
    aspect-ratio: 1 / 1;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:h-28 {
    height: 7rem;
  }

  .sm\\:h-32 {
    height: 8rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-72 {
    height: 18rem;
  }

  .sm\\:h-\\[100px\\] {
    height: 100px;
  }

  .sm\\:h-\\[120px\\] {
    height: 120px;
  }

  .sm\\:h-\\[140px\\] {
    height: 140px;
  }

  .sm\\:h-\\[260px\\] {
    height: 260px;
  }

  .sm\\:h-\\[300px\\] {
    height: 300px;
  }

  .sm\\:h-\\[350px\\] {
    height: 350px;
  }

  .sm\\:h-\\[360px\\] {
    height: 360px;
  }

  .sm\\:h-\\[480px\\] {
    height: 480px;
  }

  .sm\\:h-\\[60px\\] {
    height: 60px;
  }

  .sm\\:min-h-\\[180px\\] {
    min-height: 180px;
  }

  .sm\\:min-h-\\[460px\\] {
    min-height: 460px;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-28 {
    width: 7rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-\\[100px\\] {
    width: 100px;
  }

  .sm\\:w-\\[120px\\] {
    width: 120px;
  }

  .sm\\:w-\\[140px\\] {
    width: 140px;
  }

  .sm\\:w-\\[194\\.64px\\] {
    width: 194.64px;
  }

  .sm\\:w-\\[210px\\] {
    width: 210px;
  }

  .sm\\:w-\\[220px\\] {
    width: 220px;
  }

  .sm\\:w-\\[325px\\] {
    width: 325px;
  }

  .sm\\:w-\\[335px\\] {
    width: 335px;
  }

  .sm\\:w-\\[480px\\] {
    width: 480px;
  }

  .sm\\:w-\\[60px\\] {
    width: 60px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[200px\\] {
    min-width: 200px;
  }

  .sm\\:max-w-\\[200px\\] {
    max-width: 200px;
  }

  .sm\\:max-w-\\[80\\%\\] {
    max-width: 80%;
  }

  .sm\\:-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-3 {
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:bg-center {
    background-position: center;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:\\!px-4 {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-\\[80px\\] {
    padding-left: 80px;
    padding-right: 80px;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:text-end {
    text-align: end;
  }

  .sm\\:\\!text-sm {
    font-size: 14px !important;
  }

  .sm\\:\\!text-xs {
    font-size: 12px !important;
  }

  .sm\\:text-2xl {
    font-size: 40px;
  }

  .sm\\:text-3xl {
    font-size: 50px;
  }

  .sm\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .sm\\:text-base {
    font-size: 16px;
  }

  .sm\\:text-base-18 {
    font-size: 18px;
  }

  .sm\\:text-base-20 {
    font-size: 20px;
  }

  .sm\\:text-lg {
    font-size: 24px;
  }

  .sm\\:text-sm {
    font-size: 14px;
  }

  .sm\\:text-xl {
    font-size: 32px;
  }

  .sm\\:text-xs {
    font-size: 12px;
  }

  .sm\\:leading-normal {
    line-height: 1.5;
  }
}

@media (min-width: 768px) {

  .md\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-start-2 {
    grid-column-start: 2;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:mb-\\[60px\\] {
    margin-bottom: 60px;
  }

  .md\\:mt-\\[60px\\] {
    margin-top: 60px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-\\[120px\\] {
    height: 120px;
  }

  .md\\:h-\\[130px\\] {
    height: 130px;
  }

  .md\\:h-\\[240px\\] {
    height: 240px;
  }

  .md\\:h-\\[280px\\] {
    height: 280px;
  }

  .md\\:h-\\[360px\\] {
    height: 360px;
  }

  .md\\:h-\\[440px\\] {
    height: 440px;
  }

  .md\\:h-\\[450px\\] {
    height: 450px;
  }

  .md\\:h-\\[76px\\] {
    height: 76px;
  }

  .md\\:max-h-\\[460px\\] {
    max-height: 460px;
  }

  .md\\:min-h-\\[160px\\] {
    min-height: 160px;
  }

  .md\\:min-h-\\[220px\\] {
    min-height: 220px;
  }

  .md\\:min-h-\\[600px\\] {
    min-height: 600px;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-8 {
    width: 2rem;
  }

  .md\\:w-\\[120px\\] {
    width: 120px;
  }

  .md\\:w-\\[130px\\] {
    width: 130px;
  }

  .md\\:max-w-3xl {
    max-width: 48rem;
  }

  .md\\:max-w-xs {
    max-width: 20rem;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-items-stretch {
    justify-items: stretch;
  }

  .md\\:gap-0 {
    gap: 0px;
  }

  .md\\:gap-3 {
    gap: 0.75rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    gap: 2rem;
  }

  .md\\:gap-lg {
    gap: 32px;
  }

  .md\\:gap-md {
    gap: 24px;
  }

  .md\\:border {
    border-width: 1px;
  }

  .md\\:border-e {
    border-inline-end-width: 1px;
  }

  .md\\:bg-fixed {
    background-attachment: fixed;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:p-20 {
    padding: 5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:px-\\[100px\\] {
    padding-left: 100px;
    padding-right: 100px;
  }

  .md\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .md\\:px-\\[60px\\] {
    padding-left: 60px;
    padding-right: 60px;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pe-4 {
    padding-inline-end: 1rem;
  }

  .md\\:ps-4 {
    padding-inline-start: 1rem;
  }

  .md\\:pt-6 {
    padding-top: 1.5rem;
  }

  .md\\:text-2xl {
    font-size: 40px;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .md\\:text-base {
    font-size: 16px;
  }

  .md\\:text-base-18 {
    font-size: 18px;
  }

  .md\\:text-lg {
    font-size: 24px;
  }

  .md\\:text-lg-28 {
    font-size: 28px;
  }

  .md\\:leading-loose {
    line-height: 2;
  }
}

@media (min-width: 992px) {

  .lg\\:invisible {
    visibility: hidden;
  }

  .lg\\:\\!sticky {
    position: sticky !important;
  }

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:top-20 {
    top: 5rem;
  }

  .lg\\:top-\\[75px\\] {
    top: 75px;
  }

  .lg\\:top-\\[unset\\] {
    top: unset;
  }

  .lg\\:z-\\[0\\] {
    z-index: 0;
  }

  .lg\\:order-none {
    order: 0;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }

  .lg\\:mt-\\[137px\\] {
    margin-top: 137px;
  }

  .lg\\:mt-\\[148px\\] {
    margin-top: 148px;
  }

  .lg\\:mt-\\[80px\\] {
    margin-top: 80px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-\\[110px\\] {
    height: 110px;
  }

  .lg\\:h-\\[220px\\] {
    height: 220px;
  }

  .lg\\:h-\\[360px\\] {
    height: 360px;
  }

  .lg\\:h-\\[420px\\] {
    height: 420px;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }

  .lg\\:h-\\[calc\\(100vh-75px\\)\\] {
    height: calc(100vh - 75px);
  }

  .lg\\:h-\\[unset\\] {
    height: unset;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:min-h-\\[584px\\] {
    min-height: 584px;
  }

  .lg\\:min-h-\\[calc\\(100vh-240px\\)\\] {
    min-height: calc(100vh - 240px);
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:w-\\[110px\\] {
    width: 110px;
  }

  .lg\\:w-\\[300px\\] {
    width: 300px;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:max-w-\\[60\\%\\] {
    max-width: 60%;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:-translate-y-\\[90px\\] {
    --tw-translate-y: -90px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:gap-0 {
    gap: 0px;
  }

  .lg\\:gap-10 {
    gap: 2.5rem;
  }

  .lg\\:gap-6 {
    gap: 1.5rem;
  }

  .lg\\:rounded-md {
    border-radius: 16px;
  }

  .lg\\:border {
    border-width: 1px;
  }

  .lg\\:border-e {
    border-inline-end-width: 1px;
  }

  .lg\\:border-e-2 {
    border-inline-end-width: 2px;
  }

  .lg\\:border-s {
    border-inline-start-width: 1px;
  }

  .lg\\:bg-gray-light {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-transparent {
    background-color: transparent;
  }

  .lg\\:bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-top {
    background-position: top;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-\\[30px\\] {
    padding: 30px;
  }

  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:px-\\[30px\\] {
    padding-left: 30px;
    padding-right: 30px;
  }

  .lg\\:px-\\[8\\] {
    padding-left: 8;
    padding-right: 8;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:py-\\[120px\\] {
    padding-top: 120px;
    padding-bottom: 120px;
  }

  .lg\\:py-\\[18px\\] {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .lg\\:pe-6 {
    padding-inline-end: 1.5rem;
  }

  .lg\\:pe-8 {
    padding-inline-end: 2rem;
  }

  .lg\\:pe-\\[30px\\] {
    padding-inline-end: 30px;
  }

  .lg\\:ps-6 {
    padding-inline-start: 1.5rem;
  }

  .lg\\:ps-8 {
    padding-inline-start: 2rem;
  }

  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .lg\\:pt-8 {
    padding-top: 2rem;
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-start {
    text-align: start;
  }

  .lg\\:\\!text-base {
    font-size: 16px !important;
  }

  .lg\\:text-3xl {
    font-size: 50px;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-base-18 {
    font-size: 18px;
  }

  .lg\\:leading-1\\.2 {
    line-height: 1.2;
  }

  .lg\\:opacity-0 {
    opacity: 0;
  }

  .lg\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .before\\:lg\\:bottom-3::before {
    content: var(--tw-content);
    bottom: 0.75rem;
  }

  .before\\:lg\\:block::before {
    content: var(--tw-content);
    display: block;
  }

  .first\\:lg\\:pt-6:first-child {
    padding-top: 1.5rem;
  }

  .group\\/submenu:hover .group-hover\\/submenu\\:lg\\:visible {
    visibility: visible;
  }

  .group\\/submenu:hover .group-hover\\/submenu\\:lg\\:mt-0 {
    margin-top: 0px;
  }

  .group\\/submenu:hover .group-hover\\/submenu\\:lg\\:opacity-100 {
    opacity: 1;
  }

  .group.hasScrolled .group-\\[\\.hasScrolled\\]\\:lg\\:\\!bg-black {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1)) !important;
  }

  .group.hasScrolled .group-\\[\\.hasScrolled\\]\\:lg\\:\\!text-white {
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
  }
}

@media (min-width: 1200px) {

  .xl\\:order-2 {
    order: 2;
  }

  .xl\\:order-3 {
    order: 3;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .xl\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-\\[180px\\] {
    height: 180px;
  }

  .xl\\:h-\\[280px\\] {
    height: 280px;
  }

  .xl\\:h-\\[480px\\] {
    height: 480px;
  }

  .xl\\:h-\\[600px\\] {
    height: 600px;
  }

  .xl\\:min-h-\\[680px\\] {
    min-height: 680px;
  }

  .xl\\:w-\\[180px\\] {
    width: 180px;
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:gap-12 {
    gap: 3rem;
  }

  .xl\\:p-8 {
    padding: 2rem;
  }

  .xl\\:px-\\[100px\\] {
    padding-left: 100px;
    padding-right: 100px;
  }

  .xl\\:text-start {
    text-align: start;
  }

  .xl\\:\\!text-base {
    font-size: 16px !important;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1400px) {

  .xxl\\:\\!-end-10 {
    inset-inline-end: -2.5rem !important;
  }

  .xxl\\:\\!-start-10 {
    inset-inline-start: -2.5rem !important;
  }

  .xxl\\:-left-10 {
    left: -2.5rem;
  }

  .xxl\\:-right-10 {
    right: -2.5rem;
  }

  .xxl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .xxl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xxl\\:h-\\[280px\\] {
    height: 280px;
  }

  .xxl\\:h-\\[500px\\] {
    height: 500px;
  }

  .xxl\\:h-\\[600px\\] {
    height: 600px;
  }

  .xxl\\:min-h-\\[calc\\(100vh-137px\\)\\] {
    min-height: calc(100vh - 137px);
  }

  .xxl\\:gap-6 {
    gap: 1.5rem;
  }

  .xxl\\:px-\\[140px\\] {
    padding-left: 140px;
    padding-right: 140px;
  }

  .xxl\\:py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px;
  }
}

@media (min-width: 1640px) {

  .\\33xl\\:h-\\[560px\\] {
    height: 560px;
  }

  .\\33xl\\:p-10 {
    padding: 2.5rem;
  }
}

.rtl\\:rotate-0:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:rotate-180:where([dir="rtl"], [dir="rtl"] *) {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:-scale-x-100:where([dir="rtl"], [dir="rtl"] *) {
  --tw-scale-x: -1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.rtl\\:flex-row-reverse:where([dir="rtl"], [dir="rtl"] *) {
  flex-direction: row-reverse;
}

.rtl\\:\\!font-arabic:where([dir="rtl"], [dir="rtl"] *) {
  font-family: Droid Arabic Kufi !important;
}

.rtl\\:\\!font-500:where([dir="rtl"], [dir="rtl"] *) {
  font-weight: 500 !important;
}

.rtl\\:font-500:where([dir="rtl"], [dir="rtl"] *) {
  font-weight: 500;
}

.rtl\\:leading-3:where([dir="rtl"], [dir="rtl"] *) {
  line-height: .75rem;
}

.rtl\\:before\\:\\!translate-x-1\\/2:where([dir="rtl"], [dir="rtl"] *)::before {
  content: var(--tw-content);
  --tw-translate-x: 50% !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child {
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end) {
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
}

.\\[\\&\\>span\\]\\:hover\\:\\!scale-100:hover>span {
  --tw-scale-x: 1 !important;
  --tw-scale-y: 1 !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.\\[\\&_p\\]\\:mb-4 p {
  margin-bottom: 1rem;
}

.\\[\\&_p\\]\\:text-base p {
  font-size: 16px;
}

.\\[\\&_p\\]\\:font-400 p {
  font-weight: 400;
}

.\\[\\&_p\\]\\:leading-relaxed p {
  line-height: 1.625;
}

.\\[\\&_p\\]\\:text-dark p {
  --tw-text-opacity: 1;
  color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,mBAAoB;EAApB;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAoB;IAApB,mBAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA,gBAAoB;IAApB,mBAAoB;IAApB;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mDAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AACnB;;4CAE4C;;AAU1C;EAAA;AAAuD;;AAAvD;;EAAA;IAAA;EAAuD;AAAA;;AAAvD;;EAAA;IAAA;EAAuD;AAAA;;AAGzD;EACE,wCAAwC;AAC1C;AAEE;EAAA;AAAwB;AAGxB;EAAA;AAAkB;AAAlB;;EAAA;AAAkB;AAEpB;EACE,gEAAgE;AAClE;;AAEA;;EAEE,iEAAyD;EAAzD,yDAAyD;AAC3D;;AAGE;EAAA,sBAA4C;EAA5C,eAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;AAG5C;EAAA,sBAA4C;EAA5C,eAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;;AAI5C;EAAA,sBAA4C;EAA5C,eAA4C;EAA5C,gBAA4C;EAA5C,oBAA4C;EAA5C;AAA4C;;AAI5C;EAAA,iBAAoF;EAApF,kBAAoF;EAApF,gBAAoF;EAApF,oBAAoF;EAApF,4BAAoF;EAApF,qBAAoF;EAApF,kBAAoF;EAApF,eAAoF;EAApF,oBAAoF;EAApF;AAAoF;;AAApF;;EAAA;IAAA,cAAoF;IAApF;EAAoF;AAAA;;AAIpF;EAAA,iBAAoF;EAApF,kBAAoF;EAApF,gBAAoF;EAApF,oBAAoF;EAApF,4BAAoF;EAApF,qBAAoF;EAApF,kBAAoF;EAApF,eAAoF;EAApF,oBAAoF;EAApF;AAAoF;;AAApF;;EAAA;IAAA,cAAoF;IAApF;EAAoF;AAAA;;AAGtF,0BAA0B;AAExB;EAAA;AAAmB;;AAGrB;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4DAA4D;EAC5D,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EAGE,qBAAqB;AACvB;;AAGE;EAAA;AAAY;;AAGd;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa;EACf;AACF;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAGE;EAAA,eAAqC;EAArC,gBAAqC;EAArC,oBAAqC;EAArC;AAAqC;;AAIrC;EAAA,eAAqC;EAArC,gBAAqC;EAArC,oBAAqC;EAArC;AAAqC;;AAIrC;EAAA,eAAoC;EAApC,gBAAoC;EAApC,oBAAoC;EAApC;AAAoC;;AAIpC;EAAA,eAAoC;EAApC,gBAAoC;EAApC,oBAAoC;EAApC;AAAoC;;AAIpC;EAAA,eAAyC;EAAzC,gBAAyC;EAAzC,oBAAyC;EAAzC;AAAyC;;AAIzC;EAAA,eAAyC;EAAzC,gBAAyC;EAAzC,oBAAyC;EAAzC;AAAyC;;AAIzC;EAAA,eAAyC;EAAzC,gBAAyC;EAAzC,oBAAyC;EAAzC;AAAyC;;AAIzC;EAAA;AAAkB;;AAIlB;EAAA,iBAA0C;EAA1C;AAA0C;;AAA1C;;EAAA;IAAA,iBAA0C;IAA1C;EAA0C;AAAA;;AAA1C;;EAAA;IAAA,iBAA0C;IAA1C;EAA0C;AAAA;;AAI1C;EAAA,oBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,oBAAW;EAAX;AAAW;;AAIX;EAAA;AAAa;;AAIb;EAAA;AAAc;;AAId;EAAA;AAAa;;AAIb;EAAA;AAAU;;AAIV;EAAA;AAAU;;AAIV;EAAA,kBAAe;EAAf;AAAe;;AAIf;EAAA;AAAU;;AAIV;EAAA;AAAU;;AAIV;EAAA,kBAAe;EAAf;AAAe;;AAIf;EAAA,YAAyK;EAAzK,sBAAyK;EAAzK,qBAAyK;EAAzK,iBAAyK;EAAzK,sBAAyK;EAAzK,4DAAyK;EAAzK,kBAAyK;EAAzK,4DAAyK;EAAzK,eAAyK;EAAzK,oBAAyK;EAAzK,mDAAyK;EAAzK,8BAAyK;EAAzK;AAAyK;;AAAzK;EAAA,8BAAyK;EAAzK,uCAAyK;EAAzK,oBAAyK;EAAzK;AAAyK;;AAIzK;EAAA,aAA8C;EAA9C,mBAA8C;EAA9C,uBAA8C;EAA9C;AAA8C;;AAI9C;EAAA,sBAAgC;EAAhC;AAAgC;;AAAhC;EAAA,0BAAgC;EAAhC;AAAgC;;AAIhC;EAAA,oBAAiB;EAAjB;AAAiB;;AAIjB;EAAA,WAA2B;EAA3B,kBAA2B;EAA3B;AAA2B;;AAI3B;EAAA,WAAuB;EAAvB,kBAAuB;EAAvB;AAAuB;;AAIvB;EAAA,SAAwF;EAAxF,YAAwF;EAAxF,WAAwF;EAAxF,eAAwF;EAAxF,qBAAwF;EAAxF,iBAAwF;EAAxF,sBAAwF;EAAxF,sDAAwF;EAAxF,kBAAwF;EAAxF;AAAwF;;AAIxF;EAAA,8BAAmB;EAAnB;AAAmB;;AAGrB;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAGE;EAAA,iBAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;;AAIhC;EAAA,iBAAgC;EAAhC,sBAAgC;EAAhC;AAAgC;;AAGlC;;;;;;;;;;;GAWG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAGE;EAAA,oBAAqB;EAArB;AAAqB;;AAIrB;EAAA,oBAAiB;EAAjB;AAAiB;;AAIjB;EAAA;AAAqB;;AAGvB;EACE;MACI,2BAA2B;MAC3B,oBAAoB;MACpB,sBAAsB;EAC1B;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,iBAAiB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,8BAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAGE;EAAA;AAAkB;;AAGpB;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gDAAsD;EACtD,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gDAA0D;EAC1D,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE;IACE,gDAAyD;EAC3D;EACA;IACE,gDAA6D;IAC7D,QAAQ;IACR,WAAW;IACX,+BAA+B;EACjC;AACF;;AAKE;;;EAAA;AAAmB;;AAInB;EAAA,sBAAmB;EAAnB;AAAmB;AAGnB;EAAA,sBAAwC;EAAxC,eAAwC;EAAxC,gBAAwC;EAAxC,oBAAwC;EAAxC;AAAwC;;AAIxC;EAAA,+BAA2C;EAA3C;AAA2C;;AAA3C;;EAAA;AAA2C;;AAA3C;EAAA;AAA2C;AAG3C;EAAA;AAAW;AAGX;EAAA,kBAAyJ;EAAzJ,qBAAyJ;EAAzJ,cAAyJ;EAAzJ,6BAAyJ;EAAzJ,eAAyJ;EAAzJ;AAAyJ;AAAzJ;EAAA,kBAAyJ;EAAzJ,aAAyJ;EAAzJ,uBAAyJ;EAAzJ,eAAyJ;EAAzJ,cAAyJ;EAAzJ,qBAAyJ;EAAzJ,0BAAyJ;EAAzJ,kBAAyJ;EAAzJ;AAAyJ;AAE3J,YAAY;AAgBV;;;;;;;;;;;;;;;EAAA;AAAa;;AAIb;EAAA;AAAa;;AAGf;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;;EAEvB;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA,mCAAmC;AAEjC;EAAA,sBAAmF;EAAnF,iBAAmF;EAAnF,sBAAmF;EAAnF,sDAAmF;EAAnF,kBAAmF;EAAnF,4DAAmF;EAAnF,qBAAmF;EAAnF,sBAAmF;EAAnF,qBAAmF;EAAnF,wBAAmF;EAAnF,oBAAmF;EAAnF,6CAAmF;EACnF,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB;AANmF;;AASrF,0CAA0C;AAExC;EAAA,aAA6C;EAA7C,mBAA6C;EAA7C,uBAA6C;EAA7C;AAA6C;;AAI7C;EAAA;AAAgB;;AAIhB;EAAA,oBAAkE;EAAlE,qBAAkE;EAAlE,oBAAkE;EAAlE,uBAAkE;EAAlE,oBAAkE;EAAlE,mDAAkE;EAAlE,+FAAkE;EAAlE,wDAAkE;EAAlE;AAAkE;;AAAlE;EAAA,oBAAkE;EAAlE;AAAkE;;AADpE;EAEE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAvnBA;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,wBAunBC;EAvnBD,wDAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,gBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,gBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,iBAunBC;EAvnBD,iBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,iCAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,6BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,+EAunBC;EAvnBD,mGAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,iCAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,sBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,8BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,8BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,2GAunBC;EAvnBD,yGAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,iBAunBC;EAvnBD,iBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,kBAunBC;EAvnBD,kBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,iBAunBC;EAvnBD,iBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,6BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,+BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,qBAunBC;IAvnBD;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,sBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,uBAunBC;IAvnBD,oDAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,uBAunBC;IAvnBD,2DAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,6BAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,qBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,uBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,qBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,oBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,eAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,kBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,sBAunBC;IAvnBD,8BAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,0BAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,0BAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,6BAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,+BAunBC;IAvnBD;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,eAunBC;IAvnBD;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;;EAvnBD;IAAA,mBAunBC;IAvnBD;EAunBC;;EAvnBD;IAAA,iBAunBC;IAvnBD;EAunBC;AAAA;;AAvnBD;;EAAA;IAAA;EAunBC;;EAvnBD;IAAA;EAunBC;AAAA;;AAvnBD;EAAA,iBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,mBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,gBAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,gCAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,4BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,6BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,6BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA,0BAunBC;EAvnBD,0BAunBC;EAvnBD;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA;AAunBC;;AAvnBD;EAAA,oBAunBC;EAvnBD;AAunBC","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n/* @import \"./assets/fonts/jost/font1.css\";\n@import \"./assets/fonts/ledger/font2.css\";\n@import \"./assets/fonts/nunito/font3.css\"; */\n@import \"./assets/fonts/cormorent/font-cormorant.css\";\n@import \"./assets/fonts/futura/font-futura.css\";\n@import \"./assets/fonts/nunito/font3.css\";\n@import \"./assets/fonts/cardillac/font4.css\";\n@import \"./assets/fonts/arabic/arabic.css\";\n@import \"slick-carousel/slick/slick.css\";\n@import \"slick-carousel/slick/slick-theme.css\";\n\n.container {\n  @apply max-w-full xxl:max-w-[1340px] 3xl:max-w-[1480px];\n}\n\n* {\n  -webkit-tap-highlight-color: transparent;\n}\nhtml {\n  @apply overflow-x-hidden;\n}\nbody {\n  @apply font-futura;\n}\n.hero-section {\n  /* background-image: url(\"./assets/images/banner-hero-4.jpg\"); */\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition: background-color 0s 600000s, color 0s 600000s;\n}\n\n.new-arrive-content p {\n  @apply text-base-18 font-500 mb-5 text-white;\n}\np.new-arrive-content {\n  @apply text-base-18 font-500 mb-5 text-white;\n}\n\n.new-arrive-content {\n  @apply text-base-18 font-500 mb-5 text-white;\n}\n\n.product-card-content p {\n  @apply text-black line-clamp-2 text-center sm:max-w-[80%] mx-auto text-xs sm:text-sm;\n}\n\n.product-card-content {\n  @apply text-black line-clamp-2 text-center sm:max-w-[80%] mx-auto text-xs sm:text-sm;\n}\n\n/* Global button styling */\nbutton {\n  @apply rounded-full;\n}\n\n.btn-theme {\n  z-index: 1;\n}\n\n.btn-theme::before {\n  transition: transfrom 0.3s;\n  transform-origin: 0 0;\n  transition-timing-function: cubic-bezier(0.5, 1.6, 0.4, 0.7);\n  transform: scaleY(0);\n}\n\n.btn-theme:hover::before {\n  transform: scaleY(1);\n}\n\n.btn-theme:disabled::before {\n  transform: scaleY(0);\n}\na {\n  display: inline-block;\n}\n\n.page-404-wrapper {\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.page-404-wrapper .page_404_btn {\n  position: absolute;\n  bottom: 10%;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.slick-track {\n  @apply !flex;\n}\n\n.slider_flex .slick-track {\n  display: flex !important;\n}\n\n.slider_flex .slick-track .slick-slide {\n  height: inherit !important;\n}\n\n.slider_flex .slick-track .slick-slide > div,\n.slider_flex .slick-track .slick-slide .slider_item,\n.slider_flex .slick-track .slick-slide .slider_item > div {\n  height: 100% !important;\n}\n\n/* Ensure slider container has proper width for responsive calculations */\n.slide_gap24.slick-slider .slick-list {\n  width: 100%;\n  overflow: hidden;\n}\n\n/* New Collection Swiper Pagination Styles */\n.new-collection-swiper .swiper-pagination {\n  position: relative;\n  margin-top: 24px;\n  bottom: auto;\n}\n\n.new-collection-swiper .swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  background: #d1d1d1;\n  opacity: 1;\n  margin: 0 4px;\n  transition: all 0.3s ease;\n}\n\n.new-collection-swiper .swiper-pagination-bullet-active {\n  background: #000;\n  width: 24px;\n  border-radius: 4px;\n}\n\n/* Hide pagination on tablet and desktop */\n@media (min-width: 768px) {\n  .new-collection-swiper .swiper-pagination {\n    display: none;\n  }\n}\n\n/* Popular Collection Swiper Pagination Styles */\n.popular-collection-swiper .swiper-pagination {\n  position: relative;\n  margin-top: 24px;\n  bottom: auto;\n}\n\n.popular-collection-swiper .swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  background: #d1d1d1;\n  opacity: 1;\n  margin: 0 4px;\n  transition: all 0.3s ease;\n}\n\n.popular-collection-swiper .swiper-pagination-bullet-active {\n  background: #000;\n  width: 24px;\n  border-radius: 4px;\n}\n\n/* Hide pagination on tablet and desktop */\n@media (min-width: 768px) {\n  .popular-collection-swiper .swiper-pagination {\n    display: none;\n  }\n}\n\n.slide_gap24.slick-slider {\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.slide_gap24 .slick-slide {\n  margin-left: 12px;\n  margin-right: 12px;\n}\n\n.slide_gap16.slick-slider {\n  margin-left: -8px;\n  margin-right: -8px;\n}\n\n.slide_gap16 .slick-slide {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.slide_gap12.slick-slider {\n  margin-left: -6px;\n  margin-right: -6px;\n}\n\n.slide_gap12 .slick-slide {\n  margin-left: 6px;\n  margin-right: 6px;\n}\n.slide_gap8.slick-slider {\n  margin-left: -4px;\n  margin-right: -4px;\n}\n\n.slide_gap8.slick-slide {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n\nh1 {\n  @apply text-3xl leading-1.5 text-dark;\n}\n\nh2 {\n  @apply text-2xl leading-1.5 text-dark;\n}\n\nh3 {\n  @apply text-xl leading-1.5 text-dark;\n}\n\nh4 {\n  @apply text-lg leading-1.5 text-dark;\n}\n\nh5 {\n  @apply text-base-20 leading-1.5 text-dark;\n}\n\nh6 {\n  @apply text-base-18 leading-1.5 text-dark;\n}\n\np {\n  @apply text-sm leading-1.5 text-gray-dark;\n}\n\nlabel {\n  @apply leading-1.5;\n}\n\n.section-gap {\n  @apply py-[32px] lg:py-[60px] md:py-[40px];\n}\n\n.slick-arrow::before {\n  @apply text-black;\n}\n\n.radio-slider.slick-slider {\n  @apply px-6;\n}\n\n.radio-slider.slick-slider .slick-arrow.slick-prev {\n  @apply left-0;\n}\n\n.radio-slider.slick-slider .slick-arrow.slick-next {\n  @apply right-0;\n}\n\n.hidden-scrollbar::-webkit-scrollbar {\n  @apply hidden;\n}\n\n.theme-scrollbar::-webkit-scrollbar {\n  @apply w-1;\n}\n\n.theme-scrollbar::-webkit-scrollbar-track {\n  @apply w-1;\n}\n\n.theme-scrollbar::-webkit-scrollbar-thumb {\n  @apply bg-black;\n}\n\n::-webkit-scrollbar {\n  @apply w-1;\n}\n\n::-webkit-scrollbar-track {\n  @apply w-1;\n}\n\n::-webkit-scrollbar-thumb {\n  @apply bg-black;\n}\n\n.custom-otp-input-wrapper input {\n  @apply bg-gray-light border border-gray-mid focus:border-black/10 focus:text-black focus:bg-gold/10 text-base text-gray-dark !w-[60px] h-[50px] rounded-full outline-none;\n}\n\n.custom-otp-input-wrapper > div {\n  @apply flex items-center justify-center gap-md;\n}\n\ninput.peer-sorting:checked + label > span {\n  @apply border-black before:block;\n}\n\ninput.peer-sorting:checked + label {\n  @apply text-black;\n}\n\n.sorting-range {\n  @apply h-[6px] bg-[#F6F2EF];\n}\n\n.sorting-range .track-1 {\n  @apply h-[6px] bg-black;\n}\n\n.sorting-range .thumb {\n  @apply w-4 h-4 rounded-full bg-white border-[2px] border-black -top-[5px] cursor-pointer;\n}\n\n.sorting-range .thumb.active {\n  @apply outline-none;\n}\n\n.custome_rating span svg {\n  height: 50px;\n  width: 50px;\n}\n\n.custome_rating span svg.text-yellow-700 {\n  fill: #fbc02d;\n}\n\n.custome_rating span svg.text-blue-gray-500 {\n  stroke: #95a9b2;\n}\n\n.sub-slider .slick-slider .slick-arrow::before {\n  content: \"\";\n}\n\n.sub-slider .slick-slider .slick-slide .product-img-tiny {\n  @apply border-[3px] border-white;\n}\n\n.sub-slider .slick-slider .slick-slide.slick-current .product-img-tiny {\n  @apply border-[3px] border-black;\n}\n\n/* .slick-slider.gap-16 .slick-track{\n    gap: 16px;\n    margin-left: 16px;\n    \n}\n\n.slick-slider.gap_0 .slick-track{\n    gap: 0;\n    margin-left: -12px;\n    margin-right: -12px;\n    \n} */\n\n.slick-slider.fixed_slider .slick-track {\n  left: 0 !important;\n}\n\n.slick-slider.related_slider .slick-track {\n  left: 0 !important;\n}\n\n.slick-slider.new_collection_slider .slick-track {\n  left: 0 !important;\n}\n\n.custom_pagination .page-item {\n  @apply text-gray-dark;\n}\n\n.custom_pagination .page-item.active {\n  @apply text-black;\n}\n\n.slick-dots {\n  @apply -bottom-[30px];\n}\n\n@media (min-width: 992px) {\n  .filter_part {\n      position: sticky !important;\n      top: 75px !important;\n      align-self: flex-start;\n  }\n  \n  .search-results-section-content {\n      overflow: visible;\n  }\n  \n  .search-results-section {\n      overflow: visible;\n  }\n}\n\n@media (max-width: 576px) {\n  .slick-slider.fixed_slider .slick-track {\n    left: 30px !important;\n  }\n\n  .slick-slider.related_slider .slick-track {\n    left: 30px !important;\n  }\n\n  .slick-slider.new_collection_slider .slick-track {\n    left: -5px !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .sub-menu-anime {\n    animation: 0.5s ease 0s 1 normal forwards running slideRight;\n  }\n}\n\n@keyframes slideRight {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0%);\n  }\n}\n\n/* \n.new-arrives-section{\n    background-image: url(\"./assets/images/banner-bg.png\");\n} */\n\n.location-info-section h5 {\n  max-width: 130px;\n  overflow-x: hidden;\n  overflow-y: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  @apply !font-nunito;\n}\n\n.custom-dots .slick-dots {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.custom-dots .slick-dots li {\n  width: 6px;\n  height: 6px;\n  border-radius: 12px;\n  background-color: #76777b99;\n  display: block;\n  padding: 0px;\n  margin: 0px;\n  transition: all 0.5s ease;\n  bottom: 12px;\n}\n\n.custom-dots .slick-dots li button {\n  height: unset;\n  width: unset;\n  padding: 0;\n}\n\n.custom-dots .slick-dots li button:before {\n  display: none;\n}\n\n.custom-dots .slick-dots li.slick-active {\n  width: 16px;\n  background-color: #76777b;\n}\n\n[dir=\"rtl\"] .slick-slide {\n  @apply !float-none;\n}\n\n.fancy-heading-shape {\n  position: relative;\n  /* background-color: #ffffff; */\n}\n\n.fancy-heading-shape::before {\n  content: url(\"./assets/images/fancy-text-updated.svg\");\n  position: absolute;\n  top: 58%;\n  left: 0;\n  transform: translate(-50%, -50%);\n  z-index: -1;\n}\n\nbody[dir=\"rtl\"] .fancy-heading-shape::before {\n  content: url(\"./assets/images/fancy-text-updated-rtl.svg\");\n  right: 0;\n  left: unset;\n  transform: translate(50%, -50%);\n}\n\n@media (max-width: 768px) {\n  .fancy-heading-shape::before {\n    content: url(\"./assets/images/fancy-text-sm-updated.svg\");\n  }\n  body[dir=\"rtl\"] .fancy-heading-shape::before {\n    content: url(\"./assets/images/fancy-text-sm-updated-rtl.svg\");\n    right: 0;\n    left: unset;\n    transform: translate(50%, -50%);\n  }\n}\n\nbody[dir=\"rtl\"],\nbody[dir=\"rtl\"] .font-cormorant,\nbody[dir=\"rtl\"] .font-futura {\n  @apply !font-arabic;\n}\n\n.legal-docs h4 {\n  @apply text-lg mb-1;\n}\n.legal-docs p {\n  @apply text-base font-400 mb-3 text-dark;\n}\n\n.legal-docs h4 strong {\n  @apply font-600 font-cormorant rtl:font-500;\n}\n.legal-docs ul {\n  @apply mb-3;\n}\n.legal-docs ul li {\n  @apply relative ps-3 mb-2 block text-base font-400 before:w-1 before:h-1 before:bg-dark before:absolute before:top-2.5 before:start-0 before:rounded-full;\n}\n/* slider  */\n.product-details-slider.slick-slider,\n.product-details-slider.slick-slider .slick-list,\n.product-details-slider.slick-slider .slick-list .slick-track,\n.product-details-slider.slick-slider .slick-list .slick-track .slick-slide,\n.product-details-slider.slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide\n  > div,\n.product-details-slider.slick-slider\n  .slick-list\n  .slick-track\n  .slick-slide\n  > div\n  .product-main-img {\n  @apply h-full;\n}\n\n.product-details-slider.slick-slider .slick-list {\n  @apply h-full;\n}\n\n.slick-slide {\n  z-index: 990;\n}\n\n.slick-active.slick-current {\n  z-index: 991;\n}\n\n.gm-ui-hover-effect {\n  top: 0 !important;\n  right: 0 !important;\n  width: auto !important;\n  height: auto !important;\n\n  span {\n    font-size: 20px !important;\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n\n/* Pagination active page styling */\n.active-page {\n  @apply font-bold text-black bg-gray-light px-3 py-1.5 rounded border-2 border-black;\n  min-width: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  background-color: #f6f2ef;\n}\n\n/* Responsive pagination default styling */\n.react-responsive-pagination .pagination {\n  @apply flex items-center justify-center gap-2;\n}\n\n.react-responsive-pagination .pagination li {\n  @apply list-none;\n}\n\n.react-responsive-pagination .pagination a {\n  @apply text-gray-dark hover:text-black transition-colors px-2 py-1;\n  min-width: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
